import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useLegacyApi } from '../../../routes/legacyApiHook';
import BookingCheck from '../components/BookingCheck';
import { BookingCheckState } from '../../../routes/reducers/types';
import useTrackEcommerce from '../../../features/tracking/useTrackEcommerce';

import bookingData from '../static/bookingData';
import { RootState } from '../../../config/redux/types';
import { BOOKING_CHECK } from '../../../routes/config/pageTypes';
import { TrackProductItem } from '../../../features/tracking/types';

function buildTrackingIdentifier(
  lang: string | undefined,
  bookingCheck: BookingCheckState | undefined,
): string | null {
  if (lang == null || bookingCheck == null || bookingCheck.accommodation == null) {
    return null;
  }
  return [lang, bookingCheck.accommodation.id.toString(), bookingCheck.amount_total].join('-');
}

function buildTrackingItems(bookingCheck?: BookingCheckState): TrackProductItem[] | null {
  if (!bookingCheck || !bookingCheck.accommodation) {
    return null;
  }
  return [
    {
      id: bookingCheck.accommodation.id.toString(),
      item_id: bookingCheck.accommodation.id.toString(),
      name: bookingCheck.accommodation.display_title,
      item_name: bookingCheck.accommodation.display_title,
      quantity: 1,
      price: bookingCheck.amount_total,
    },
  ];
}

export default function BookingCheckContainer(): JSX.Element | null {
  const { lang } = useParams<'lang'>();
  const bookingCheck = useSelector((state: RootState) => state.routes.bookingCheck);

  useTrackEcommerce(
    { event: 'checkout_progress', items: buildTrackingItems(bookingCheck) },
    buildTrackingIdentifier(lang, bookingCheck),
  );

  useLegacyApi(undefined, BOOKING_CHECK);

  if (!bookingCheck) {
    return null;
  }

  return <BookingCheck {...bookingCheck} {...bookingData()} />;
}
